module.exports = __webpack_public_path__ + "img/bottom.7c1a2eaa.png";